"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkflow = exports.WorkflowEvents = void 0;
var react_1 = require("@xstate/react");
var react_2 = require("react");
var use_workflow_analytics_1 = require("../../components/use-workflow-analytics");
var WorkflowEvents;
(function (WorkflowEvents) {
    WorkflowEvents["NEXT"] = "NEXT";
    WorkflowEvents["BACK"] = "BACK";
    WorkflowEvents["ERROR"] = "ERROR";
})(WorkflowEvents = exports.WorkflowEvents || (exports.WorkflowEvents = {}));
function useWorkflow(options) {
    var machine = options.machine, onComplete = options.onComplete, analyticsClient = options.analyticsClient, name = options.name;
    var _a = (0, react_1.useMachine)(machine), state = _a[0], send = _a[1], service = _a[2];
    var _b = (0, react_2.useState)(false), isExitWarningDisabled = _b[0], setIsExitWarningDisabled = _b[1];
    // prevent an infinite loop by saving onComplete on a ref
    var onCompleteHandler = (0, react_2.useRef)(onComplete).current;
    // Tracking the start and end of the workflow
    (0, use_workflow_analytics_1.useWorkflowAnalytics)({
        analyticsClient: analyticsClient,
        workflowName: name,
        isComplete: !!state.done,
    });
    (0, react_2.useEffect)(function () {
        if (state.done) {
            onCompleteHandler(state.context);
        }
    }, [state.done, state.context, onCompleteHandler]);
    // show a warning prompt when the user attempts to close/reload the page with unfinished changes
    (0, react_2.useLayoutEffect)(function () {
        if (isExitWarningDisabled) {
            return;
        }
        var listener = function (e) {
            e.preventDefault(); // cross-browser compatibility
            var warningMessage = 
            // eslint-disable-next-line max-len
            'You have unsaved changes in this workflow. Do you want to leave and discard your changes or stay on this page?';
            if (state.done === false) {
                // cross-browser compatibility; not guaranteed to display the warning message on most browsers
                e.returnValue = warningMessage;
                return warningMessage;
            }
        };
        window.addEventListener('beforeunload', listener);
        return function () {
            window.removeEventListener('beforeunload', listener);
        };
    }, [isExitWarningDisabled, state.done]);
    return {
        service: service,
        currentStep: state.value,
        isComplete: state.done || false,
        toJSON: function () { return state.toJSON(); },
        context: state.context,
        isCurrentStep: function (step) { return state.matches(step); },
        toggleExitWarning: function () {
            setIsExitWarningDisabled(function (isDisabled) { return !isDisabled; });
        },
        nextStep: function (data) {
            send({
                type: WorkflowEvents.NEXT,
                data: data,
            });
        },
        previousStep: function (data) {
            send({
                type: WorkflowEvents.BACK,
                data: data,
            });
        },
    };
}
exports.useWorkflow = useWorkflow;
